var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cc page pageAsOverlay" },
    [
      _c("AppHead"),
      _vm.url
        ? _c("div", {}, [
            _c("iframe", {
              staticStyle: {
                height: "92vh",
                width: "100%",
                "background-color": "transparent",
              },
              attrs: {
                src: _vm.url,
                sandbox:
                  "allow-forms allow-same-origin allow-scripts allow-modals allow-popups",
                frameborder: "0",
              },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }